import { FirebaseError } from 'firebase/app'

const POISTUMISEN_KESTO_MS = 10_000

export class SivultaPoistuminen {
  private _alkoi: number | null = null

  // Safari ja Firefox keskeyttävät kesken olevat pyynnöt jo beforeunloadin jälkeen, Chrome vasta pagehiden jälkeen.
  // Tiedoston lataus siirtymällä sen osoitteeseen laukaisee beforeunloadin, vaikka sivu jää auki, joten poistuminen on voimassa vain hetken.
  constructor(ikkuna: EventTarget) {
    const merkitseAlkaneeksi = () => {
      this._alkoi = Date.now()
    }
    ikkuna.addEventListener('beforeunload', merkitseAlkaneeksi)
    ikkuna.addEventListener('pagehide', merkitseAlkaneeksi)
  }

  keskeyttiFunktiokutsun(virhe: unknown) {
    const poistuminenKaynnissa = this._alkoi !== null && Date.now() - this._alkoi < POISTUMISEN_KESTO_MS
    return poistuminenKaynnissa && virhe instanceof FirebaseError && virhe.code === 'functions/internal' && virhe.message === 'internal [0]'
  }
}
